import { FC } from "react";
import {
  EnvironmentFilled,
  PhoneFilled,
  MailFilled,
  PrinterFilled,
} from "@ant-design/icons";
import classes from "./Footer.module.scss";
import { HashLink } from "react-router-hash-link";
import { localeTo } from "../utils/helpers";
import { localeData } from "../data/locale";
import { useAppSelector } from "../utils/hooks";
import { Skeleton } from "antd";
import SocialItem from "./SocialItem";
import cx from "classnames";
import { keys } from "../apis";
// images
import { ReactComponent as Twitter } from "../images/icons/twitter.svg";
import { ReactComponent as Instagram } from "../images/icons/instagram.svg";
import { ReactComponent as Facebook } from "../images/icons/facebook.svg";
import { ReactComponent as LinkedIn } from "../images/icons/linkedin.svg";
import { ReactComponent as WhatsApp } from "../images/icons/whatsapp.svg";
import { ReactComponent as YouTube } from "../images/icons/youtube.svg";
import { ReactComponent as NavArrow } from "../images/icons/nav-arrow.svg";
import footerLogo from "../images/footer-logo.png";

const defaultNav = [
  {
    path: "/contracting",
    name: localeData.cont,
  },
  {
    path: "/equipments",
    name: localeData.equipments,
    exact: true,
  },
  {
    path: "/transport",
    name: localeData.transport,
  },
  {
    path: "/",
    name: localeData.home,
  },
  {
    path: "/jobs",
    name: localeData.jobs,
  },
];
interface Props {
  siteKey?: keys;
  navItems?: typeof defaultNav;
  logo?: string;
}
const Footer: FC<Props> = ({
  navItems = defaultNav,
  siteKey = keys.public,
  logo = footerLogo,
}) => {
  const { status, data } = useAppSelector((state) => state.settings[siteKey]);

  return (
    <footer className={classes.footer}>
      <div className={cx("container", classes.content)}>
        <img
          src={logo}
          alt="SATC Logo"
          className={cx(classes.footerLogo, "h-auto")}
        />
        <nav>
          <ul className={cx("mt-lg-4", classes.navMenu)}>
            {navItems.map(({ name, path }, i) => (
              <li key={i}>
                <HashLink to={localeTo(path)}>
                  <NavArrow data-arrow="" />
                  {name}
                </HashLink>
              </li>
            ))}
          </ul>
        </nav>
        <section className={classes.info}>
          <h3 className="mb-3">{localeData.contact}</h3>
          <Skeleton active loading={status === "loading"} />
          {status === "succeeded" && (
            <>
              <ul className={`${classes.contactList} mb-3`}>
                <li>
                  <EnvironmentFilled data-icon="" />
                  {data?.address}
                </li>
                <li>
                  <a href={`tel:${data?.phone}`}>
                    <PhoneFilled data-icon="" />
                    <span dir="ltr">{data?.phone}</span>
                  </a>
                </li>
                <li>
                  <PrinterFilled data-icon="" />
                  {<span dir="ltr">{data?.fax}</span>}
                </li>
                <li>
                  <a href={`mailto:${data?.email}`}>
                    <MailFilled data-icon="" />
                    {data?.email}
                  </a>
                </li>
              </ul>
              <ul className={classes.socialMenu}>
                <SocialItem href={data?.twitter}>
                  <Twitter title="Twitter" />
                </SocialItem>
                <SocialItem href={data?.instagram}>
                  <Instagram />
                </SocialItem>
                <SocialItem href={data?.facebook}>
                  <Facebook title="Facebook" />
                </SocialItem>
                <SocialItem href={data?.linkedin}>
                  <LinkedIn title="LinkedIn" />
                </SocialItem>
                <SocialItem href={data?.youtube}>
                  <YouTube title="YouTube" />
                </SocialItem>
                <SocialItem href={data?.whatsapp}>
                  <WhatsApp title="WhatsApp" />
                </SocialItem>
              </ul>
            </>
          )}
        </section>
      </div>
      <div className={classes.copyrights}>
        <div className="container">
          <p className="mb-0">{localeData.copyrights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
